require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberwart-markt-allhau.json") })
        }
      }, "path---betreuungseinrichtungen-oberwart-markt-allhau");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberwart-markt-allhau!./.cache/json/betreuungseinrichtungen-oberwart-markt-allhau.json
// module id = 1013
// module chunks = 231608221292675